/* eslint-disable react/destructuring-assignment */
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import type { ActionMeta } from 'react-select';

import { SelectInput, ISelectInputProps, ISelectOption } from './SelectInput';
import { Tooltip } from './Tooltip';

type Value = ISelectInputProps['value'];
export type ISelectInputFieldProps = ISelectInputProps & FieldProps<Value, FieldRenderProps<Value>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkMetaError: (error: any) => any = error => {
  if (!error) return error;

  switch (typeof error) {
    case 'object':
      return Object.keys(error).length > 0;
    default:
      return error;
  }
};

export const SelectInputField = (props: ISelectInputFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function handleChange(activeOption: any, actionMeta: ActionMeta<ISelectOption>) {
        const value = !activeOption || activeOption?.length === 0 ? undefined : activeOption;

        input.onChange(value);
        if (props.onChange) {
          props.onChange(value, actionMeta);
        }
      }

      const error =
        typeof props.error === 'boolean'
          ? props.error && checkMetaError(meta.error)
          : meta.touched && checkMetaError(meta.error);
      const errorOnSubmit =
        checkMetaError(meta.error) && (meta.dirty || meta.submitFailed) && meta.touched && checkMetaError(meta.error);

      const selectInput = () => {
        return (
          <SelectInput
            {...props}
            {...input}
            onChange={handleChange}
            invalid={Boolean(props.validateOnSubmit ? errorOnSubmit : error)}
            error={props.validateOnSubmit ? errorOnSubmit : error}
          />
        );
      };

      // @ts-ignore
      const tooltipText = input?.value?.title;

      if (props.isShowTooltip && tooltipText) {
        return (
          <Tooltip
            placement="topLeft"
            type="label"
            content={<p style={{ margin: `8px` }}>{tooltipText}</p>}
            maxWidth={props.tooltipWidth}
          >
            {selectInput()}
          </Tooltip>
        );
      }

      return selectInput();
    }}
  </Field>
);

// Используется для показа описания у индикатора риска в КНМ. До этого показывался title - Приказ, что неверно.
export const SelectInputFieldWithDescription = (props: ISelectInputFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function handleChange(activeOption: any, actionMeta: ActionMeta<ISelectOption>) {
        const value = !activeOption || activeOption?.length === 0 ? undefined : activeOption;

        input.onChange(value);
        if (props.onChange) {
          props.onChange(value, actionMeta);
        }
      }

      const error =
        typeof props.error === 'boolean'
          ? props.error && checkMetaError(meta.error)
          : meta.touched && checkMetaError(meta.error);
      const errorOnSubmit =
        checkMetaError(meta.error) && (meta.dirty || meta.submitFailed) && meta.touched && checkMetaError(meta.error);

      const selectInput = () => {
        return (
          <SelectInput
            {...props}
            {...input}
            onChange={handleChange}
            invalid={Boolean(props.validateOnSubmit ? errorOnSubmit : error)}
            error={props.validateOnSubmit ? errorOnSubmit : error}
          />
        );
      };

      // @ts-ignore
      const tooltipText = input?.value?.description || input?.value?.title;

      if (props.isShowTooltip && tooltipText) {
        return (
          <Tooltip
            placement="topLeft"
            type="label"
            content={<p style={{ margin: `8px` }}>{tooltipText}</p>}
            maxWidth={props.tooltipWidth}
          >
            {selectInput()}
          </Tooltip>
        );
      }

      return selectInput();
    }}
  </Field>
);
